import { useState, useEffect } from 'react';

const FloatingWhatsApp = () => {
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowBubble(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-end gap-2">
      {/* Text bubble */}
      {showBubble && !dismissed && (
        <div
          className="animate-fade-in bg-white rounded-xl shadow-lg px-4 py-2.5 mb-1 relative max-w-[160px]"
          style={{ animation: 'fadeSlideIn 0.4s ease-out' }}
        >
          <button
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDismissed(true); }}
            className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-gray-500 text-xs leading-none"
            aria-label="Dismiss"
          >
            ×
          </button>
          <p className="text-xs font-semibold text-gray-800 leading-tight">
            Book a free trial session! 📚
          </p>
          {/* Speech bubble arrow */}
          <div className="absolute right-4 -bottom-1.5 w-3 h-3 bg-white rotate-45 shadow-sm" />
        </div>
      )}

      {/* WhatsApp button */}
      <a
        href="https://wa.me/94743652899"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="flex-shrink-0 w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 overflow-hidden"
      >
        <img
          src="/pngegg.png"
          alt="WhatsApp"
          className="w-full h-full object-contain"
        />
      </a>

      <style>{`
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default FloatingWhatsApp;
